import { usePromptTemplateParameters } from 'chatspot-ui-components/templates/hooks/usePromptTemplateParameters';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useIsUngatedForCopilotV2 } from '../../gating/hooks/useIsUngatedForCopilotV2';
import { useSelectedPromptTemplate } from '../../promptTemplates/hooks/useSelectedPromptTemplate';
import { selectDraftParameterValues } from '../../promptTemplates/selectors/promptTemplateSelectors';
import { selectCreateThreadStatus } from '../../threads/selectors/threadsSelectors';
import { selectIsWaitingForChatResponse as v1SelectIsWaitingForChatResponse } from '../selectors/chatSelectors';
import { selectIsWaitingForResponse as v2SelectIsWaitingForResponse } from '../selectors/chatv2Selectors';
export const useIsSendMessageDisabled = () => {
  const selectedTemplate = useSelectedPromptTemplate();
  const parameters = usePromptTemplateParameters(selectedTemplate);
  const draftParameterValues = useSelector(selectDraftParameterValues);
  const createThreadStatus = useSelector(selectCreateThreadStatus);

  // TODO: Remove this once we drop chatv1.
  const isUngatedForCopilotV2 = useIsUngatedForCopilotV2();
  const v1IsWaitingForChatResponse = useSelector(v1SelectIsWaitingForChatResponse);
  const v2IsWaitingForChatResponse = useSelector(v2SelectIsWaitingForResponse);
  const isWaitingForChatResponse = isUngatedForCopilotV2 ? v2IsWaitingForChatResponse : v1IsWaitingForChatResponse;
  const areParametersMissing = useMemo(() => {
    if (parameters.length === 0) {
      return false;
    }
    return parameters.some(parameter => !(draftParameterValues[parameter.id] || '').trim() && !parameter.optional);
  }, [draftParameterValues, parameters]);
  if (selectedTemplate) {
    return areParametersMissing || isWaitingForChatResponse || createThreadStatus === 'loading';
  }
  return isWaitingForChatResponse || createThreadStatus === 'loading';
};